var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video flex flex-column"},[_c('dark-header'),_c('div',{staticClass:"flex flex-between player-container"},[_c(_vm.realComponent,{tag:"component",staticClass:"flex-item player",attrs:{"video":_vm.video}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }